import "./SingleGalleryItemTemplate.module.css"
import PulseThreadEntry from "@/reusable_sections/Header"
import SingleGalleryItemTemplateSection from "./sections/SingleGalleryItemTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleGalleryItemTemplatePage() {

  return (
    <div>
      <PulseThreadEntry />
      <SingleGalleryItemTemplateSection />
      <Footer />
    </div>
  )
}
